var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"page-cabinet-estates-list-table-item-row"},_vm._l((_vm.fields),function(field,i){return _c('div',{key:i,staticClass:"page-cabinet-estates-list-table-item-row__field",domProps:{"textContent":_vm._s(field.title === 'Текущая Стоимость' ? _vm.item.currentValueFormatted : _vm.item[field.valueCode])}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }